import React from 'react';
import { Box, Container, Typography, Tabs, Tab, Paper } from '@mui/material';
import { AIChatContainer } from './index';
import { useAuth } from '../../context/AuthContext';
import useThemeStyles from '../../theme/useThemeStyles';

/**
 * Test page for AI Chat Gateway
 * Access at /ai-chat-test
 * Works for both couples and suppliers
 * 
 * Note: For suppliers, BusinessProvider must be available (access from supplier routes)
 */
const AIChatTestPage = () => {
  const styles = useThemeStyles();
  const { user, wedding } = useAuth();
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const isSupplier = user?.role === 'supplier';

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography component="h2" className="pagename" sx={styles.text.pagename}>
        AI Chat Gateway Test
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Test the new AI Gateway implementation
      </Typography>
      {isSupplier && (
        <Paper sx={{ mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Business Chat" />
            <Tab label="Wedding Chat" />
          </Tabs>
        </Paper>
      )}
      <Paper sx={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
        {!isSupplier ? (
          // Couple mode
          (<AIChatContainer
            mode="couple"
            weddingId={wedding?._id}
          />)
        ) : (
          // Supplier mode - AIChatContainer will handle BusinessProvider internally
          (tabValue === 0 ? (<AIChatContainer
            mode="supplier"
            supplierMode="business"
          />) : (<AIChatContainer
            mode="supplier"
            supplierMode="wedding"
            weddingId={wedding?._id}
          />))
        )}
      </Paper>
      <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="subtitle2" gutterBottom>
          Debug Info:
        </Typography>
        <Typography variant="body2">
          User: {user?.email} ({user?.role})
        </Typography>
        {wedding && (
          <Typography variant="body2">
            Wedding: {wedding.name} ({wedding._id})
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default AIChatTestPage;
